export const en = {
    terminals: {
        list: {
            terminalId: "Terminal Identifier",
            entity: "Entity",
            profile: "Profile",
            status: "Status",
            lastCommunication: "Last Communication",
            keepAliveTimeMinutes: "Keep Alive Time (Minutes)",
            allowAutoProvisioning: "Allow Auto-Provisioning",
            location: "Location",
            name: "Name"
        },
        status: {
            enabled: "Enabled",
            disabled: "Disabled"
        },
        allowAutoProvisioning: {
            yes: "Yes",
            no: "No"
        },
        alerts: {
            create: {
                title: "Create Terminal",
                text: "Are you sure you want to create <b>%{terminal}</b>",
                success: {
                    title: "Terminal Created Successfully",
                    text: "<b>%{terminal}</b> was created successfully",
                },
                error: {
                    title: "Terminal Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Terminal",
                text: "Are you sure you want to delete <b>%{terminal}</b>",
                success: {
                    title: "Terminal Deleted Successfully",
                    text: "You will now be redirected to the terminals page",
                },
                error: {
                    title: "Terminal Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Terminal",
                text: "Are you sure you want to edit <b>%{terminal}</b>",
                success: {
                    title: "Terminal Edited Successfully",
                    text: "<b>%{terminal}</b> was edited successfully",
                },
                error: {
                    title: "Terminal Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        page: {
            header: "Interface List"
        },
        form: {
            headers: {
                create: "Create Terminal",
                edit: "Edit Terminal",
                view: "View Terminal"
            },
            terminalIdentifier: {
                label: "Terminal Identifier",
            },
            name: {
                label: "Name",
            },
            profile: {
                label: "Profile",
            },
            entity: {
                label: "Entity",
            },
            allowAutoProvisioning: {
                label: "Allow Auto-Provisioning",
            },
            keepAliveTime: {
                label: "Keep Alive Time",
            },
            connectionState: {
                label: "Connection State",
            },
            lastCommunication: {
                label: "Last Communication",
            },
            status: {
                label: "Status",
            },
            enabled: {
                label: "Enabled",
            },
        },
        smallForm: {
            description: "Description",
            value: "Value",
            title: "Terminal Info"
        },
        errors: {
            invalidKeepAliveTime: "Invalid Keep Alive Time Format",
        },
        permissions: {
            TERMINALS: "Terminals",
            CREATE_TERMINAL: "Create terminals",
            READ_TERMINAL: "Read terminals",
            UPDATE_TERMINAL: "Update terminals",
            DELETE_TERMINAL: "Delete terminals"
        }
    }
};